module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chartsanddiagrams",
    attrs: {
      "id": "chartsanddiagrams"
    }
  }, [_c('h2', {
    staticClass: "contentsHead1"
  }, [_vm._v("CHARTS AND DIAGRAMS")]), _vm._v(" "), _c('table', {
    staticClass: "table0"
  }, [_c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('a', {
    attrs: {
      "href": "#/AttackonPearlHarbor_introduction1#cha1"
    }
  }, [_vm._v("1.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "#/AttackonPearlHarbor_introduction1#cha1"
    }
  }, [_vm._v("Chart of Pearl Harbor, 7 December 1941")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('a', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch101#cha2"
    }
  }, [_vm._v("2.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch101#cha2"
    }
  }, [_vm._v("World Distribution of Battleships, 6 December 1941")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('a', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch103#cha3"
    }
  }, [_vm._v("3.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch103#cha3"
    }
  }, [_vm._v("World Distribution of Battleships, 1 January 1942")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch201#cha4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch201#cha4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("US Technical Mission to Japan Ordnance Data Page, 800-kg AP bomb")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch203#cha5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch203#cha5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("US Technical Mission to Japan Ordnance Data Page, 250-kg GP bomb")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch401#cha6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch401#cha6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Torpedo Bomber Planned Attack Routes")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch403#cha7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch403#cha7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AP Bombing Anticipated Results")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch405#cha8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch405#cha8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Number of Inboard Battleships Crippled or Sunk")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch407#cha9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch407#cha9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Japanese Aircraft Approach Routes")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch701#cha10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch701#cha10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Timeline of Planned Torpedo Attacks on Carriers and Battleship Row")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch702#cha11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch702#cha11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Actual Development of Torpedo Attacks on Carriers and Battleship Row")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch704#cha12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch704#cha12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AP Bombing Under Actual and Expected Conditions")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch706#cha13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch706#cha13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Distribution of Number of Inboard Battleships Sunk or Crippled")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch708#cha14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch708#cha14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Submarine Patrol Areas")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch801#cha15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch801#cha15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Torpedo Hits: Claimed and Actual")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch803#cha16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch803#cha16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AP Bomb Hits: Claimed and Actual")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch805#cha17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch805#cha17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GP Bombs: Hits Claimed and Attacks Claimed")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch807#cha18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch807#cha18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GP Bombs: Hits Claimed and Actual Hits")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch809#cha19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch809#cha19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GP Bombs: Hits Claimed and US Records of Attacks")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch1101#cha20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20.")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/AttackonPearlHarbor_ch1101#cha20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fifth Midget Submarine: Event Flow Chart")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c53790","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AttackonPearlHarbor_chartsanddiagrams.vue
// module id = 69
// module chunks = 0